<script>
  import { Flex, FlexItem, GL } from "@gl/design-system";
  import { createEventDispatcher, onDestroy, onMount } from "svelte";

  export let oktaSignIn;
  export let signInOptions = {};

  const dispatch = createEventDispatcher();

  const init = async () => {
    try {
      const tokens = await oktaSignIn.showSignInToGetTokens({
        ...signInOptions,
        el: "#widget-container",
      });

      oktaSignIn.authClient.tokenManager.setTokens(tokens);

      dispatch("success", tokens);
    } catch (err) {
      dispatch("fail", err);
    }
  };

  onMount(() => {
    init();
  });

  onDestroy(() => {
    oktaSignIn.remove();
  });
</script>

<div id="login-page">
  <Flex class="flex-direction-column align-items-center">
    <FlexItem class="mb-5">
      <GL light />
    </FlexItem>
    <FlexItem>
      <h1 class="header">
        <slot name="header" />
      </h1>
    </FlexItem>
    <FlexItem>
      <div id="widget-container" />
    </FlexItem>
  </Flex>
</div>

<!-- https://github.com/sveltejs/svelte/issues/5530#issuecomment-1001595722 -->
<svelte:head>
  <style lang="scss">
    @use "@gl/design-system/src/styles/main.scss";
    #login-page {
      background-color: #002735;
      min-width: 100vw;
      min-height: 100vh;
      padding-top: 8rem;

      .header {
        color: var(--gl-grey);
        font-weight: 200;
        font-size: 30px;
        text-transform: uppercase;
        text-align: center;
      }
    }

    #okta-sign-in {
      &.auth-container {
        &.main-container {
          background-color: transparent;
          border: none;
          box-shadow: none;
          margin: 0 auto;
        }

        h2 {
          color: var(--gl-white);
        }

        #okta-signin-submit {
          width: auto;
        }

        .button {
          @extend .gl-button;
          text-align: center;

          &.button-primary {
            @extend .is-status-primary;
          }

          &:active {
            @extend .gl-button, :active;
            text-align: center;
          }

          &:focus {
            @extend .gl-button, :focus;
            text-align: center;
          }

          &:hover {
            @extend .gl-button, :hover;
            text-align: center;
          }
        }

        .link,
        .link:link {
          color: var(--gl-white) !important;
          font-size: 14px;
          opacity: 0.3;
        }

        .o-form-label {
          @extend .gl-form-label;
          color: var(--gl-white);
        }

        .okta-sign-in-header {
          border: none;
        }
      }

      .o-form-button-bar {
        text-align: left;
        box-shadow: none;
      }

      .okta-form-title {
        @extend .gl-title;
        margin-bottom: var(--gl-spacing-6);
      }

      .primary-auth-form .okta-form-title {
        text-align: left;
      }
    }
  </style>
</svelte:head>
